import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShoppingBag } from '@fortawesome/free-solid-svg-icons'
import './Cart.css'

const Cart = (props) => {
    const cart = props.cart
    // console.log(cart);
    const total = cart.reduce((total, user) => total + Number(user.income), 0)
    // let total = 0
    // for (let i = 0; i < cart.length; i++) {
    //     const user = cart[i];
    //     total += Number(user.income)
    // }


    return (
      
           

            <div className="div-position">

                <div className="following half-width">
                    <h2 className="text"><strong> {cart.length} </strong></h2>
                    <button class="btn btn-success btn-block"><span class="fa fa-plus-circle"></span> Total Following </button>
                </div>
                <div className="following half-width">
                    <h2 className="text"><strong> ${total} </strong></h2>
                    <button class="btn btn-success btn-block"><span class="fa fa-plus-circle"></span> Total Yearly Income </button>
                </div>
            
            </div>


    );
};

export default Cart;